import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const SchoolIcon = createIcon({
  displayName: 'SchoolIcon',
  path: (
    <>
      <path stroke='none' d='M0 0h24v24H0z' />
      <path d='M22 9 12 5 2 9l10 4 10-4v6' />
      <path d='M6 10.6V16a6 3 0 0 0 12 0v-5.4' />
    </>
  ),
  defaultProps: {
    ...defaultProps,
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }
})
